module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bergdietikon-e4f319cfa703e8283d8e43652d356e83.svg";